import Typography from '@mui/material/Typography';
import MonhrlyTable from './MonhrlyTable';
import { getAcisData, windchill, heatindex, setupFilters } from '../js/dataAccessRoutines';

// Hourly data for a month processing //

const setMonhrlyResults = (results, setResult) => {
  if (results) {
      const code = (
        <MonhrlyTable 
            tabledata={results.tabledata}
            hours_to_use={results.hours_to_use}
            userParams={results.userParams}
            stnName={results.stnName}
        />
      );
      setResult(code)
  } else {
    setResult("")
  }
}

const processData = (res, userParams) => {
  var vals
  const tabledata = []
  const stnName = res.meta.name + ", " + res.meta.state
  const {hours_to_use} = setupFilters(userParams)
  //process
  res.data.forEach((results, i) => {
    let rowvals = {}
    let dlysum = 0
    let dlycnt = 0
    let [yy, mm, dd] = results[0].split("-")
    rowvals.day = parseInt(dd)
    // derived variables
    if (userParams.variable === 'wchill') {
      vals = windchill(results[1], results[2], '-')
    } else if (userParams.variable === 'htindx') {
      vals = heatindex(results[1], results[2], '-')
    } else {
      vals = results[1]
    }
    vals.forEach((rval, hh) => {
      if (hours_to_use.includes(hh+1)) {  //first hour is 01, thus hh+1 here
        var rval_format =  rval === "-0" || (userParams.variable === 'pcpn' && rval === "0.00") ? "0" : rval
        if (userParams.variable === "wgust" && rval_format === "M") {
          rval_format = "-"
        }
        rowvals[hh+1] = rval_format
        if (!['-','M',"T"].includes(rval)) {
          dlysum += parseFloat(rval)
          dlycnt += 1
        }
      }
    })
    if (['pcpn', 'srad'].includes(userParams.variable)) {
      rowvals.smry =  dlycnt > 0 ? dlysum.toFixed(userParams.variable === 'pcpn' ? 2 : 1) : "M"
    } else {
      rowvals.smry = dlycnt > 0 ? (dlysum / dlycnt).toFixed(['pres','slp','altp','vis'].includes(userParams.variable) ? 2 : 1) : "M"
    }
    tabledata.push(rowvals)
  })
  return {tabledata, hours_to_use, userParams, stnName}
}

export function processMonhrly(userParams, setResult, hourlyVx) {
    const sid = userParams.sid;
    const network = sid.indexOf(" ") > 0 ? sid.split(" ")[1] : 'icao';
    // some variables need to be calculated from others; get what's needed
    var elems;
    if (userParams.variable === 'wchill') {
      elems = [ {vX: hourlyVx[network]['temp']}, {vX: hourlyVx[network]['wspd']} ]
    } else if (userParams.variable === 'htindx') {
      elems = [ {vX: hourlyVx[network]['temp']}, {vX: hourlyVx[network]['rhum']} ]
    } else {
      elems = [ {vX: hourlyVx[network][userParams.variable]} ]
    }
    const acisParams = {
        sid: sid,
        sDate: userParams.fromDate.set('date', 1).format('YYYY-MM-DD'),
        eDate: userParams.fromDate.endOf('month').format('YYYY-MM-DD'),
        elems: elems
    }
    getAcisData(acisParams)
    .then(res => {
      const results = processData(res, userParams);
      setMonhrlyResults(results, setResult)
    })
    .catch(error =>  { 
      console.log("Data retrieval error: " + error);  
      setResult((
        <Typography sx={{color: "red"}}>
          Error processing request - error
        </Typography>
      ))
    })
}